import React, { Component } from 'react';
import AppRoutes from './AppRoutes';
import { Layout } from './components/Layout';
import logo from './logo.svg';
import './App.css';
import { Route, Routes } from 'react-router';

export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <Layout>
                <Routes>
                    {AppRoutes.map((route, index) => {
                        const { element, ...rest } = route;
                        return <Route key={index} {...rest} element={element} />;
                    })}
                </Routes>
            </Layout>
        );
    }
}

